// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListingDiscounts-badge-h7prS {
    position: absolute;
    inset-inline-start: 24px;
    top: 26px;
    z-index: 2;
    max-width: calc(100% - 96px);
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 6px;
    padding: 5px 14px 5px 5px;
    border-radius: 999px;
    background: #16794f;
    color: #fff;
    font-size: 15px;
    font-weight: 400;
    line-height: 1.4;
    pointer-events: none;
}
.ListingDiscounts-icon-n3NTU {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    -ms-flex-negative: 0;
        flex-shrink: 0;
    width: 22px;
    height: 22px;
    -webkit-margin-end: 6px;
            margin-inline-end: 6px;
    border-radius: 50%;
    background: #e6f5ed;
    color: #07663f;
    font-weight: 700;
}
.ListingDiscounts-badge-h7prS .ListingDiscounts-icon-n3NTU {
    width: 20px;
    height: 20px;
    -webkit-margin-end: 0;
            margin-inline-end: 0;
    font-size: 11px;
}
.ListingDiscounts-panel-n32pJ {
    margin: 0 0 20px;
    padding: 14px 16px;
    border: 1px solid #cce5d8;
    border-radius: 10px;
    background: #f2faf5;
    color: #07663f;
    font-size: 14px;
    line-height: 1.6;
    overflow-wrap: anywhere;
}
.ListingDiscounts-panel-n32pJ strong { display: block; }
.ListingDiscounts-panel-n32pJ p { margin: 6px 0; }
.ListingDiscounts-panel-n32pJ small { display: block; font-size: 12px; color: #365b48; }
.ListingDiscounts-offers-Ibur1 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    gap: 8px 20px;
    list-style: none;
    padding: 0;
    margin: 10px 0;
    font-weight: 600;
}
.ListingDiscounts-conditions-ZdG33 summary { cursor: pointer; font-size: 12px; text-decoration: underline; }
.ListingDiscounts-conditions-ZdG33 small { margin-top: 6px; }
.ListingDiscounts-nextPanel-zscOB {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    gap: 12px;
    margin: 0 0 16px;
    background: linear-gradient(125deg, #eefaf3, #f8fcf9);
}
.ListingDiscounts-nextIcon-MG63h {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -ms-flex-negative: 0;
        flex-shrink: 0;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: #d9f2e4;
    color: #087f50;
    font-size: 16px;
}
.ListingDiscounts-nextContent-wt1Rr { min-width: 0; -webkit-box-flex: 1; -ms-flex: 1 1; flex: 1 1; }
.ListingDiscounts-nextContent-wt1Rr strong { line-height: 1.45; }
.ListingDiscounts-extendButton-QJyC9 {
    display: block;
    width: 100%;
    margin-top: 10px;
    padding: 8px 12px;
    border: 1px solid #087f50;
    border-radius: 6px;
    background: #fff;
    color: #087f50;
    font-weight: 700;
    line-height: 1.4;
    cursor: pointer;
}
.ListingDiscounts-extendButton-QJyC9:hover, .ListingDiscounts-extendButton-QJyC9:focus {
    background: #e6f5ed;
}
.ListingDiscounts-offersCard-Owbi1 {
    margin: 0 0 24px;
    padding: 14px;
    border-radius: 18px;
    background: #eaf7f0;
    color: #125e40;
}
.ListingDiscounts-offersRow-GkFgY { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-align: stretch; -ms-flex-align: stretch; align-items: stretch; gap: 10px; }
.ListingDiscounts-offersHeader-QXDQg { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-flex: 45; -ms-flex: 45 1; flex: 45 1; min-width: 0; -webkit-box-align: center; -ms-flex-align: center; align-items: center; gap: 8px; }
.ListingDiscounts-offersTexts-OZtVa { min-width: 0; }
.ListingDiscounts-titleTop-aUALZ { display: block; white-space: nowrap; font-size: 15px; font-weight: 500; line-height: 1.15; color: #125e40; }
.ListingDiscounts-offersHeader-QXDQg strong { display: block; white-space: nowrap; font-size: 20px; font-weight: 700; line-height: 1.15; color: #125e40; }
.ListingDiscounts-offersHeader-QXDQg small { display: block; margin-top: 4px; font-size: 12.5px; font-weight: 300; line-height: 1.3; color: #365b48; }
.ListingDiscounts-offersSeal-Ned2f { display: -webkit-inline-box; display: -ms-inline-flexbox; display: inline-flex; -ms-flex-negative: 0; flex-shrink: 0; }
.ListingDiscounts-tiles-UGB3g {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 55;
        -ms-flex: 55 1;
            flex: 55 1;
    min-width: 0;
    gap: 8px;
    list-style: none;
    margin: 0;
    padding: 0 0 0 10px;
    -webkit-border-start: 1px solid #cce5d8;
            border-inline-start: 1px solid #cce5d8;
}
.ListingDiscounts-tile-Lx8Jx {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
        -ms-flex: 1 1;
            flex: 1 1;
    min-width: 0;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    gap: 2px;
    padding: 10px 4px;
    border-radius: 14px;
    background: #f7fcf9;
    text-align: center;
}
.ListingDiscounts-tileName-Ob2Le { font-size: 13px; color: #365b48; white-space: nowrap; }
.ListingDiscounts-tileName-Ob2Le .glyphicon { color: #16794f; }
.ListingDiscounts-tilePercent-fxYMl { font-size: 26px; font-weight: 800; line-height: 1.15; color: #16794f; white-space: nowrap; }
.ListingDiscounts-tileDays-_szms { font-size: 13px; color: #365b48; white-space: nowrap; }
/* Medium phones: same layout, slightly smaller. */
@media (max-width: 420px) {
    .ListingDiscounts-offersCard-Owbi1 { padding: 12px; }
    .ListingDiscounts-titleTop-aUALZ { font-size: 12.5px; }
    .ListingDiscounts-offersHeader-QXDQg strong { font-size: 16px; }
    .ListingDiscounts-offersHeader-QXDQg small { font-size: 11px; }
    .ListingDiscounts-offersSeal-Ned2f svg { width: 24px; height: 24px; }
    .ListingDiscounts-tilePercent-fxYMl { font-size: 22px; }
    .ListingDiscounts-tileName-Ob2Le, .ListingDiscounts-tileDays-_szms { font-size: 11.5px; }
}
/* Small phones: seal moves above the title, everything shrinks. */
@media (max-width: 340px) {
    .ListingDiscounts-offersCard-Owbi1 { padding: 10px; }
    .ListingDiscounts-offersRow-GkFgY { gap: 6px; }
    .ListingDiscounts-offersHeader-QXDQg { -webkit-box-orient: vertical; -webkit-box-direction: normal; -ms-flex-direction: column; flex-direction: column; -webkit-box-align: start; -ms-flex-align: start; align-items: flex-start; gap: 4px; -ms-flex-preferred-size: 38%; flex-basis: 38%; }
    .ListingDiscounts-tiles-UGB3g { gap: 5px; -webkit-padding-start: 6px; padding-inline-start: 6px; }
    .ListingDiscounts-tile-Lx8Jx { padding: 8px 2px; }
    .ListingDiscounts-titleTop-aUALZ { font-size: 11px; }
    .ListingDiscounts-offersHeader-QXDQg strong { font-size: 13.5px; }
    .ListingDiscounts-offersHeader-QXDQg small { font-size: 9.5px; }
    .ListingDiscounts-offersSeal-Ned2f svg { width: 22px; height: 22px; }
    .ListingDiscounts-tilePercent-fxYMl { font-size: 17px; }
    .ListingDiscounts-tileName-Ob2Le, .ListingDiscounts-tileDays-_szms { font-size: 10px; }
}
.ListingDiscounts-offersCard-Owbi1 .ListingDiscounts-conditions-ZdG33 { margin-top: 10px; }
.ListingDiscounts-summary-yKwBg {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 10px;
    margin: 0 0 16px;
    padding: 8px 12px;
    border-radius: 10px;
    background: #eaf7f0;
    color: #07663f;
}
.ListingDiscounts-summaryIcon-wYDLs {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -ms-flex-negative: 0;
        flex-shrink: 0;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #087f50;
    color: #fff;
    font-size: 12px;
    font-weight: 700;
}
.ListingDiscounts-summaryOffers-P9R7e { display: -webkit-box; display: -ms-flexbox; display: flex; -ms-flex-wrap: wrap; flex-wrap: wrap; gap: 2px 14px; list-style: none; margin: 0; padding: 0; font-size: 13px; font-weight: 600; }
.ListingDiscounts-badgeIcon-HIepJ { display: -webkit-inline-box; display: -ms-inline-flexbox; display: inline-flex; -ms-flex-negative: 0; flex-shrink: 0; }
`, "",{"version":3,"sources":["webpack://./src/components/ListingDiscounts/ListingDiscounts.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,SAAS;IACT,UAAU;IACV,4BAA4B;IAC5B,2BAAoB;IAApB,2BAAoB;IAApB,oBAAoB;IACpB,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,2BAAoB;IAApB,2BAAoB;IAApB,oBAAoB;IACpB,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,oBAAc;QAAd,cAAc;IACd,WAAW;IACX,YAAY;IACZ,uBAAsB;YAAtB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAoB;YAApB,oBAAoB;IACpB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;AACA,uCAAgB,cAAc,EAAE;AAChC,kCAAW,aAAa,EAAE;AAC1B,sCAAe,cAAc,EAAE,eAAe,EAAE,cAAc,EAAE;AAChE;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,mBAAe;QAAf,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,UAAU;IACV,cAAc;IACd,gBAAgB;AACpB;AAEA,6CAAsB,eAAe,EAAE,eAAe,EAAE,0BAA0B,EAAE;AACpF,2CAAoB,eAAe,EAAE;AACrC;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,qDAAqD;AACzD;AACA;IACI,2BAAoB;IAApB,2BAAoB;IAApB,oBAAoB;IACpB,oBAAc;QAAd,cAAc;IACd,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;AACA,sCAAe,YAAY,EAAE,mBAAO,EAAP,aAAO,EAAP,SAAO,EAAE;AACtC,6CAAsB,iBAAiB,EAAE;AACzC;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;AACA,oCAAa,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,0BAAoB,EAApB,uBAAoB,EAApB,oBAAoB,EAAE,SAAS,EAAE;AAC7D,uCAAgB,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,oBAAY,EAAZ,cAAY,EAAZ,UAAY,EAAE,YAAY,EAAE,yBAAmB,EAAnB,sBAAmB,EAAnB,mBAAmB,EAAE,QAAQ,EAAE;AAC1F,sCAAe,YAAY,EAAE;AAC7B,mCAAY,cAAc,EAAE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,cAAc,EAAE;AACvH,8CAAuB,cAAc,EAAE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,cAAc,EAAE;AAClI,6CAAsB,cAAc,EAAE,eAAe,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC9H,qCAAc,2BAAoB,EAApB,2BAAoB,EAApB,oBAAoB,EAAE,oBAAc,EAAd,cAAc,EAAE;AACpD;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,oBAAY;QAAZ,cAAY;YAAZ,UAAY;IACZ,YAAY;IACZ,QAAQ;IACR,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,uCAAsC;YAAtC,sCAAsC;AAC1C;AACA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,mBAAW;QAAX,aAAW;YAAX,SAAW;IACX,YAAY;IACZ,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;AACA,mCAAY,eAAe,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAClE,8CAAgC,cAAc,EAAE;AAChD,sCAAe,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAC1G,mCAAY,eAAe,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAClE,kDAAkD;AAClD;IACI,qCAAc,aAAa,EAAE;IAC7B,mCAAY,iBAAiB,EAAE;IAC/B,8CAAuB,eAAe,EAAE;IACxC,6CAAsB,eAAe,EAAE;IACvC,yCAAkB,WAAW,EAAE,YAAY,EAAE;IAC7C,sCAAe,eAAe,EAAE;IAChC,qEAAuB,iBAAiB,EAAE;AAC9C;AACA,kEAAkE;AAClE;IACI,qCAAc,aAAa,EAAE;IAC7B,oCAAa,QAAQ,EAAE;IACvB,uCAAgB,4BAAsB,EAAtB,6BAAsB,EAAtB,0BAAsB,EAAtB,sBAAsB,EAAE,wBAAuB,EAAvB,qBAAuB,EAAvB,uBAAuB,EAAE,QAAQ,EAAE,4BAAe,EAAf,eAAe,EAAE;IAC5F,gCAAS,QAAQ,EAAE,0BAAyB,EAAzB,yBAAyB,EAAE;IAC9C,+BAAQ,gBAAgB,EAAE;IAC1B,mCAAY,eAAe,EAAE;IAC7B,8CAAuB,iBAAiB,EAAE;IAC1C,6CAAsB,gBAAgB,EAAE;IACxC,yCAAkB,WAAW,EAAE,YAAY,EAAE;IAC7C,sCAAe,eAAe,EAAE;IAChC,qEAAuB,eAAe,EAAE;AAC5C;AACA,wEAA0B,gBAAgB,EAAE;AAC5C;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,2BAAoB;IAApB,2BAAoB;IAApB,oBAAoB;IACpB,oBAAc;QAAd,cAAc;IACd,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA,wCAAiB,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,mBAAe,EAAf,eAAe,EAAE,aAAa,EAAE,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAE5I,oCAAa,2BAAoB,EAApB,2BAAoB,EAApB,oBAAoB,EAAE,oBAAc,EAAd,cAAc,EAAE","sourcesContent":[".badge {\n    position: absolute;\n    inset-inline-start: 24px;\n    top: 26px;\n    z-index: 2;\n    max-width: calc(100% - 96px);\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 5px 14px 5px 5px;\n    border-radius: 999px;\n    background: #16794f;\n    color: #fff;\n    font-size: 15px;\n    font-weight: 400;\n    line-height: 1.4;\n    pointer-events: none;\n}\n.icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: 22px;\n    height: 22px;\n    margin-inline-end: 6px;\n    border-radius: 50%;\n    background: #e6f5ed;\n    color: #07663f;\n    font-weight: 700;\n}\n.badge .icon {\n    width: 20px;\n    height: 20px;\n    margin-inline-end: 0;\n    font-size: 11px;\n}\n.panel {\n    margin: 0 0 20px;\n    padding: 14px 16px;\n    border: 1px solid #cce5d8;\n    border-radius: 10px;\n    background: #f2faf5;\n    color: #07663f;\n    font-size: 14px;\n    line-height: 1.6;\n    overflow-wrap: anywhere;\n}\n.panel strong { display: block; }\n.panel p { margin: 6px 0; }\n.panel small { display: block; font-size: 12px; color: #365b48; }\n.offers {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px 20px;\n    list-style: none;\n    padding: 0;\n    margin: 10px 0;\n    font-weight: 600;\n}\n\n.conditions summary { cursor: pointer; font-size: 12px; text-decoration: underline; }\n.conditions small { margin-top: 6px; }\n.nextPanel {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    margin: 0 0 16px;\n    background: linear-gradient(125deg, #eefaf3, #f8fcf9);\n}\n.nextIcon {\n    display: inline-flex;\n    flex-shrink: 0;\n    align-items: center;\n    justify-content: center;\n    width: 34px;\n    height: 34px;\n    border-radius: 50%;\n    background: #d9f2e4;\n    color: #087f50;\n    font-size: 16px;\n}\n.nextContent { min-width: 0; flex: 1; }\n.nextContent strong { line-height: 1.45; }\n.extendButton {\n    display: block;\n    width: 100%;\n    margin-top: 10px;\n    padding: 8px 12px;\n    border: 1px solid #087f50;\n    border-radius: 6px;\n    background: #fff;\n    color: #087f50;\n    font-weight: 700;\n    line-height: 1.4;\n    cursor: pointer;\n}\n.extendButton:hover, .extendButton:focus {\n    background: #e6f5ed;\n}\n\n.offersCard {\n    margin: 0 0 24px;\n    padding: 14px;\n    border-radius: 18px;\n    background: #eaf7f0;\n    color: #125e40;\n}\n.offersRow { display: flex; align-items: stretch; gap: 10px; }\n.offersHeader { display: flex; flex: 45 1 0; min-width: 0; align-items: center; gap: 8px; }\n.offersTexts { min-width: 0; }\n.titleTop { display: block; white-space: nowrap; font-size: 15px; font-weight: 500; line-height: 1.15; color: #125e40; }\n.offersHeader strong { display: block; white-space: nowrap; font-size: 20px; font-weight: 700; line-height: 1.15; color: #125e40; }\n.offersHeader small { display: block; margin-top: 4px; font-size: 12.5px; font-weight: 300; line-height: 1.3; color: #365b48; }\n.offersSeal { display: inline-flex; flex-shrink: 0; }\n.tiles {\n    display: flex;\n    flex: 55 1 0;\n    min-width: 0;\n    gap: 8px;\n    list-style: none;\n    margin: 0;\n    padding: 0 0 0 10px;\n    border-inline-start: 1px solid #cce5d8;\n}\n.tile {\n    display: flex;\n    flex: 1 1 0;\n    min-width: 0;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 2px;\n    padding: 10px 4px;\n    border-radius: 14px;\n    background: #f7fcf9;\n    text-align: center;\n}\n.tileName { font-size: 13px; color: #365b48; white-space: nowrap; }\n.tileName :global(.glyphicon) { color: #16794f; }\n.tilePercent { font-size: 26px; font-weight: 800; line-height: 1.15; color: #16794f; white-space: nowrap; }\n.tileDays { font-size: 13px; color: #365b48; white-space: nowrap; }\n/* Medium phones: same layout, slightly smaller. */\n@media (max-width: 420px) {\n    .offersCard { padding: 12px; }\n    .titleTop { font-size: 12.5px; }\n    .offersHeader strong { font-size: 16px; }\n    .offersHeader small { font-size: 11px; }\n    .offersSeal svg { width: 24px; height: 24px; }\n    .tilePercent { font-size: 22px; }\n    .tileName, .tileDays { font-size: 11.5px; }\n}\n/* Small phones: seal moves above the title, everything shrinks. */\n@media (max-width: 340px) {\n    .offersCard { padding: 10px; }\n    .offersRow { gap: 6px; }\n    .offersHeader { flex-direction: column; align-items: flex-start; gap: 4px; flex-basis: 38%; }\n    .tiles { gap: 5px; padding-inline-start: 6px; }\n    .tile { padding: 8px 2px; }\n    .titleTop { font-size: 11px; }\n    .offersHeader strong { font-size: 13.5px; }\n    .offersHeader small { font-size: 9.5px; }\n    .offersSeal svg { width: 22px; height: 22px; }\n    .tilePercent { font-size: 17px; }\n    .tileName, .tileDays { font-size: 10px; }\n}\n.offersCard .conditions { margin-top: 10px; }\n.summary {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin: 0 0 16px;\n    padding: 8px 12px;\n    border-radius: 10px;\n    background: #eaf7f0;\n    color: #07663f;\n}\n.summaryIcon {\n    display: inline-flex;\n    flex-shrink: 0;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    background: #087f50;\n    color: #fff;\n    font-size: 12px;\n    font-weight: 700;\n}\n.summaryOffers { display: flex; flex-wrap: wrap; gap: 2px 14px; list-style: none; margin: 0; padding: 0; font-size: 13px; font-weight: 600; }\n\n.badgeIcon { display: inline-flex; flex-shrink: 0; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": `ListingDiscounts-badge-h7prS`,
	"icon": `ListingDiscounts-icon-n3NTU`,
	"panel": `ListingDiscounts-panel-n32pJ`,
	"offers": `ListingDiscounts-offers-Ibur1`,
	"conditions": `ListingDiscounts-conditions-ZdG33`,
	"nextPanel": `ListingDiscounts-nextPanel-zscOB`,
	"nextIcon": `ListingDiscounts-nextIcon-MG63h`,
	"nextContent": `ListingDiscounts-nextContent-wt1Rr`,
	"extendButton": `ListingDiscounts-extendButton-QJyC9`,
	"offersCard": `ListingDiscounts-offersCard-Owbi1`,
	"offersRow": `ListingDiscounts-offersRow-GkFgY`,
	"offersHeader": `ListingDiscounts-offersHeader-QXDQg`,
	"offersTexts": `ListingDiscounts-offersTexts-OZtVa`,
	"titleTop": `ListingDiscounts-titleTop-aUALZ`,
	"offersSeal": `ListingDiscounts-offersSeal-Ned2f`,
	"tiles": `ListingDiscounts-tiles-UGB3g`,
	"tile": `ListingDiscounts-tile-Lx8Jx`,
	"tileName": `ListingDiscounts-tileName-Ob2Le`,
	"tilePercent": `ListingDiscounts-tilePercent-fxYMl`,
	"tileDays": `ListingDiscounts-tileDays-_szms`,
	"summary": `ListingDiscounts-summary-yKwBg`,
	"summaryIcon": `ListingDiscounts-summaryIcon-wYDLs`,
	"summaryOffers": `ListingDiscounts-summaryOffers-P9R7e`,
	"badgeIcon": `ListingDiscounts-badgeIcon-HIepJ`
};
module.exports = ___CSS_LOADER_EXPORT___;
